import React from 'react';
import { VISA_TYPES } from '../../types/knowledge-base';

interface VisaTypeSelectorProps {
  value: string[];
  onChange: (visaTypes: string[]) => void;
}

export const VisaTypeSelector: React.FC<VisaTypeSelectorProps> = ({ value, onChange }) => {
  const handleToggle = (visaType: string) => {
    if (value.includes(visaType)) {
      onChange(value.filter((v) => v !== visaType));
    } else {
      onChange([...value, visaType]);
    }
  };

  return (
    <div className="flex flex-wrap gap-2">
      {VISA_TYPES.map((visaType) => (
        <button
          key={visaType}
          type="button"
          onClick={() => handleToggle(visaType)}
          className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
            value.includes(visaType)
              ? 'bg-blue-600 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          {visaType}
        </button>
      ))}
    </div>
  );
};
